import { toOptions } from 'components/QuestionnaireRequestAutomated/utilities/processor'
import { useOnClickOutside } from 'components/utility/hooks/useOnClickOutside'
import React, { useCallback, useRef, useState } from 'react'

export const SelectField = ({ id, field, value, placeholder, options, onChange, isSkipNa, isOpacity, endIcon }) => {
  const ref = useRef()
  const [open, setOpen] = useState(false)

  const handleSelect = useCallback(
    (value) => {
      setOpen(false)
      onChange({ [id]: value })
    },
    [onChange, id]
  )

  const handleClickInside = useCallback(() => setOpen(false), [])
  useOnClickOutside(ref, handleClickInside)
  const toggleOpen = useCallback(() => setOpen((prev) => !prev), [])

  const select_options = toOptions(options || field.options, isSkipNa)

  return (
    <div ref={ref} className="dome-d-flex dome-flex-column auto-questionnaire-auto-complete-field">
      <div
        onClick={toggleOpen}
        style={{ opacity: isOpacity ? 0.4 : 1 }}
        className="auto-complete-field-search dome-cursor-pointer"
      >
        <span className="dome-full-width">{value}</span>
        {endIcon ? endIcon : <i className="fa-light fa-solid fa-chevron-down dome-color-med-grey"></i>}
      </div>
      {open && (
        <ul className="auto-complete-field-list">
          {select_options?.map(([value, label]) => {
            return (
              <li
                key={value}
                onClick={() => handleSelect(value)}
                className="auto-complete-field-list-item dome-cursor-pointer dome-p1 dome-color-darkest-grey dome-text-w300"
              >
                {label}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
